// @ts-nocheck
import { atom } from 'recoil';

export const noteTypes = atom<any>({
  key: "noteTypes",
});

